import type { InferProps } from 'prop-types';
import type { FunctionComponent } from 'react';

import TableInfo, { type propTypes } from './table-info';

export default TableInfo as FunctionComponent<InferProps<typeof propTypes>>;
